import { render, staticRenderFns } from "./SpeakerCard.vue?vue&type=template&id=0bea2ba3&"
import script from "./SpeakerCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports